import { Col, Row } from "react-bootstrap";
import { Fragment } from "react/jsx-runtime";

export default function CCExamAssessmentSummary(){

    return (<Fragment>
        <Row className="ccassessment-pathway-title">
            <Col>
                <div className="font-weight-bolder card-title h5"><span>Examination Pathway</span></div>
                <small>Applications for Countinuing Certification Exams are available in the year prior to the assessment due date for your certificate.</small>
            </Col>
        </Row>
    </Fragment>)
}